
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-400 to-cyan-400 rounded-xl">
              <i className="ri-star-fill text-white text-xl"></i>
            </div>
            <span className={`text-xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              STELLAR LIVE
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors hover:text-pink-500 ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              ホーム
            </button>
            <button
              onClick={() => scrollToSection('talents')}
              className={`text-sm font-medium transition-colors hover:text-pink-500 ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              タレント
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors hover:text-pink-500 ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              サービス
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:text-pink-500 ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              事務所について
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors hover:text-pink-500 ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              お問い合わせ
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:block px-6 py-2.5 bg-gradient-to-r from-pink-500 to-cyan-500 text-white text-sm font-medium rounded-full hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer"
          >
            オーディション応募
          </button>
        </div>
      </div>
    </nav>
  );
}
